import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import credissuerLogo from "../../resources/images/landing/credissuer-logo.svg";
import heroBg from "../../resources/images/landing/hero-bg.png";
import heroOverlay from "../../resources/images/landing/hero-overlay.png";
import myMzansiLogo from "../../resources/images/landing/mymzansi-logo.png";
import dpiLogo from "../../resources/images/landing/dpi-logo.png";
import solapurLogo from "../../resources/images/landing/solapur-logo.png";
import partner2 from "../../resources/images/landing/partner-2.png";
import credentialHeroSvg from "../../resources/images/landing/credential-hero.svg";
import credentialHeroPng from "../../resources/images/landing/credential-hero.png";
import awsLogo from "../../resources/images/landing/partners/aws.webp";
import bcgLogo from "../../resources/images/landing/partners/bcg.svg";
import cdpiLogo from "../../resources/images/landing/partners/cdpi.webp";
import culkeyLogo from "../../resources/images/landing/partners/culkey-foundation.webp";
import cyberpwnLogo from "../../resources/images/landing/partners/cyberpwn.webp";
import dgrneLogo from "../../resources/images/landing/partners/dgrne.webp";
import e2eLogo from "../../resources/images/landing/partners/e2e.png";
import googleLogo from "../../resources/images/landing/partners/google.png";
import inicLogo from "../../resources/images/landing/partners/inic.webp";
import m2pLogo from "../../resources/images/landing/partners/m2p.png";
import openg2pLogo from "../../resources/images/landing/partners/openg2p.avif";
import oracleLogo from "../../resources/images/landing/partners/oracle.webp";
import proteanEgovLogo from "../../resources/images/landing/partners/protean-egov.webp";
import silverstripeLogo from "../../resources/images/landing/partners/silverstripe.webp";
import worldBankLogo from "../../resources/images/landing/partners/world-bank.svg";
import globalImpactLogo from "../../resources/images/landing/partners/global-impact.webp";
import govstackLogo from "../../resources/images/landing/partners/govstack.svg";
import hirekarmaLogo from "../../resources/images/landing/partners/hirekarma.webp";
import ihmLogo from "../../resources/images/landing/partners/ihm-southern-africa.webp";
import iiitbLogo from "../../resources/images/landing/partners/iiitb.webp";
import ituLogo from "../../resources/images/landing/partners/itu.webp";
import jansahasLogo from "../../resources/images/landing/partners/jansahas.webp";
import mosipLogo from "../../resources/images/landing/partners/mosip.webp";
import sakshmLogo from "../../resources/images/landing/partners/sakshm.svg";
import takshayLogo from "../../resources/images/landing/partners/takshay-labs.webp";
import unsaidTalksLogo from "../../resources/images/landing/partners/unsaidtalks.webp";
import PartnerLogoMarquee from "./PartnerLogoMarquee";

const partnerLogos = [
  { src: mosipLogo, alt: "MOSIP" },
  { src: iiitbLogo, alt: "IIIT-B" },
  { src: ituLogo, alt: "ITU", imageClassName: "max-h-[52px] max-w-[60px]" },
  { src: govstackLogo, alt: "GovStack" },
  { src: globalImpactLogo, alt: "Global Impact" },
  { src: ihmLogo, alt: "IHM Southern Africa" },
  { src: culkeyLogo, alt: "Culkey Foundation" },
  { src: jansahasLogo, alt: "Jan Sahas" },
  { src: sakshmLogo, alt: "Sakshm" },
  { src: takshayLogo, alt: "Takshay Labs" },
  { src: hirekarmaLogo, alt: "HireKarma" },
  { src: cyberpwnLogo, alt: "CyberPWN" },
  { src: unsaidTalksLogo, alt: "UnsaidTalks" },
  {
    src: solapurLogo,
    alt: "Solapur University",
    imageClassName: "h-auto max-h-[44px] w-[74px] scale-[1.8]",
  },
  {
    src: dpiLogo,
    alt: "DPI",
    imageClassName: "h-auto max-h-[36px] w-[58px] scale-[1.75]",
  },
  {
    src: myMzansiLogo,
    alt: "MyMzansi",
    imageClassName: "h-auto max-h-[38px] w-[88px] scale-[1.5]",
  },
  {
    src: partner2,
    alt: "STP",
    imageClassName: "h-auto max-h-[40px] w-[88px] scale-[1.75]",
  },
  { src: awsLogo, alt: "AWS" },
  { src: bcgLogo, alt: "Boston Consulting Group" },
  { src: cdpiLogo, alt: "CDPI" },
  { src: dgrneLogo, alt: "DGRNE" },
  { src: e2eLogo, alt: "E2E" },
  { src: googleLogo, alt: "Google" },
  { src: inicLogo, alt: "INIC" },
  { src: m2pLogo, alt: "M2P" },
  { src: openg2pLogo, alt: "OpenG2P" },
  { src: oracleLogo, alt: "Oracle" },
  { src: proteanEgovLogo, alt: "Protean eGov" },
  { src: silverstripeLogo, alt: "Silverstripe" },
  {
    src: worldBankLogo,
    alt: "World Bank Group",
    imageClassName: "h-auto max-h-[46px] w-[112px] scale-[1.25]",
  },
];

const CredentialHeroAnimation = ({ className = "" }) => {
  const [isSvgReady, setIsSvgReady] = useState(false);

  useEffect(() => {
    let isMounted = true;
    const svgImage = new Image();
    svgImage.src = credentialHeroSvg;

    const markSvgReady = () => {
      if (isMounted && svgImage.naturalWidth > 0) {
        setIsSvgReady(true);
      }
    };

    if (svgImage.complete) {
      markSvgReady();
    } else {
      svgImage.onload = markSvgReady;
      svgImage.onerror = () => {};
    }

    return () => {
      isMounted = false;
      svgImage.onload = null;
      svgImage.onerror = null;
    };
  }, []);

  return (
    <div
      className={`relative aspect-[1512/1132] h-full w-full max-h-full max-w-full ${className}`}
    >
      <img
        src={credentialHeroPng}
        alt=""
        aria-hidden="true"
        width={1512}
        height={1132}
        className={`absolute inset-0 h-full w-full object-contain transition-opacity duration-300 ${
          isSvgReady ? "opacity-0" : "opacity-100"
        }`}
      />
      <img
        src={credentialHeroSvg}
        alt=""
        aria-hidden="true"
        width={1512}
        height={1132}
        className={`absolute inset-0 h-full w-full object-contain transition-opacity duration-300 ${
          isSvgReady ? "opacity-100" : "opacity-0"
        }`}
      />
    </div>
  );
};

const LandingHero = () => {
  const { t } = useTranslation();

  return (
    <section
      aria-label={t("authPages:landing_hero_label")}
      className="relative flex h-screen w-full flex-1 flex-col overflow-hidden bg-cfLandingHeroBg"
    >
      {/* Backgrounds */}
      <img
        src={heroBg}
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 h-full w-full object-cover"
      />
      <img
        src={heroOverlay}
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 h-full w-full object-cover"
      />

      <div className="relative z-10 flex h-full flex-col py-7">
        <div className="relative z-20 shrink-0 px-10 lg:px-12 xl:px-16">
          <img
            src={credissuerLogo}
            alt="CredIssuer"
            className="h-9 w-auto max-w-[200px] object-contain"
          />

          {/* Tagline + Headline */}
          <div className="mt-4 max-w-[min(100%,22rem)] xl:max-w-[340px]">
            <p className="text-[9px] font-bold uppercase tracking-[0.18em] text-cfLandingHeroTagline xl:whitespace-nowrap xl:text-[10px] xl:tracking-[0.28em]">
              {t("authPages:landing_tagline")}
            </p>
            <h1 className="mt-2 text-[26px] font-bold leading-[1.15] text-white lg:text-[28px] xl:text-[38px]">
              <span className="block">
                {t("authPages:landing_headline_primary_line1")}
              </span>
              <span className="block">
                {t("authPages:landing_headline_primary_line2")}
              </span>
              <span className="mt-1 block font-serif text-[24px] font-normal italic lg:text-[26px] xl:text-[36px]">
                {t("authPages:landing_headline_accent")}
              </span>
            </h1>
          </div>
        </div>

        <div className="relative z-0 min-h-0 flex-1 overflow-hidden">
          <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
            <CredentialHeroAnimation className="scale-[0.88] lg:scale-[0.92] xl:scale-[1.02]" />
          </div>
        </div>

        <div className="relative z-20 mt-auto shrink-0 px-2">
          <div className="mb-3 flex items-center gap-3">
            <div className="h-px flex-1 bg-cfLandingHeroDivider" />
            <p className="whitespace-nowrap text-[11px] font-bold uppercase tracking-[0.08em] text-white">
              {t("authPages:landing_trusted_by")}
            </p>
            <div className="h-px flex-1 bg-cfLandingHeroDivider" />
          </div>

          <PartnerLogoMarquee logos={partnerLogos} />
        </div>
      </div>
    </section>
  );
};

export default LandingHero;
